const Style = {
    shell: 'flex min-h-0 flex-1 flex-col gap-6',
    header: 'space-y-1',
    title: 'text-2xl font-semibold tracking-tight text-text-primary',
    description: 'text-sm text-text-secondary',
    loading: 'space-y-4',
};

export default Style;
